import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { bindActionCreators } from 'redux';
import { firstTdStyles, subRowStyles, subRowTdStyles, tdStyles } from './PermissionGroup.css';
import ScopeSelect from '../TableInputs/ScopeSelect';
import { lastTdStyles } from '../../styles/PermissionsTable.css';
import Toggle from '../TableInputs/Toggle';
import { updateSecurityGroup } from '../../../../../../actions/SecurityGroupActions';
import ConfirmationModal from '../Permissions/ConfirmationModal';

class PermissionGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            permissionGroup: {},
            propsPermissions: [],
            permissions: [],
            showSubRows: false,
            isChecked: false,
            isGroupChecked: false,
            scopes: [],
            groupScope: 1,
            permissionModal: false,
            permissionIdsAndNames: [],
            currentPermission: ''
        };
    }

    //Update scope for an individual permission
    updateScope = (permissionName, value) => {
        //If the security group has the permission in it already
        //Update that permission
        if (this.props.securityGroup.permissions[permissionName] != null) {
            let permissions = this.props.securityGroup.permissions;
            let permission = permissions[permissionName];
            permission.scopeId = value;
            this.updateSecurityGroup('permissions', permissions);
        }

        //Either way, update the state
        let scopes = this.state.scopes;
        let index = this.getScopeIndex(permissionName);
        if (index > -1) {
            scopes[index].value = parseInt(value);
        } else scopes.push({ name: permissionName, value: parseInt(value) });
        this.setState({ scopes });
    };

    //Show or hide the permissions beneath the group
    toggleSubRows = () => {
        if (this.props.disabled) return;
        this.setState({ showSubRows: !this.state.showSubRows });
    };

    //Provide the name and value for the property to update
    //Dispatches a Redux action to update the security group
    updateSecurityGroup = (propertyName, propertyValue) => {
        let securityGroup = { ...this.props.securityGroup };
        securityGroup[propertyName] = propertyValue;
        this.props.updateSecurityGroup(securityGroup);
    };

    //Get the index of a permission in the security group.
    //If it doesn't exist, returns -1
    //If it does, returns the index with which it can be accessed
    isPermissionSelected = permissionId => {
        let permissions = this.props.securityGroup.permissions;
        return permissions[permissionId] != null;
    };

    //Get the index of the scope from state
    //If it doesn't exist, returns -1
    getScopeIndex = permissionName => {
        let scopes = this.state.scopes;
        for (let i = 0; i < scopes.length; i++) {
            if (scopes[i].name === permissionName) return i;
        }
        return -1;
    };

    isGroupScopeable = () => {
        let permissions = this.props.permissionGroup.permissions;
        let isScopeable = false;
        permissions.forEach(permission => {
            if (permission.scopeable) isScopeable = true;
        });

        return isScopeable;
    };

    removePermissionsFromGroup = securityGroupPermissions => {
        let statePermissions = this.state.permissions;

        //Iterate through permissions in state
        //If they are present in the security group
        //Remove them
        statePermissions.forEach(statePermission => {
            let id = statePermission.id;
            if (securityGroupPermissions[id]) delete securityGroupPermissions[id];
        });
        //Return security group permissions
        //After removing other permissions
        return securityGroupPermissions;
    };

    findPermissionsNotInGroup = () => {
        let statePermissions = this.state.permissions;
        let permissions = [];

        //Iterate through the permissions in state
        //If they are not in the security group
        //Add to array
        statePermissions.forEach(statePermission => {
            let name = statePermission.name;
            if (!this.isPermissionSelected(name)) permissions.push(statePermission);
        });

        //Return array of permissions not in security group
        return permissions;
    };

    togglePermissionGroupChecked = id => {
        if (this.props.disabled) return;
        let isGroupChecked = this.state.isGroupChecked;
        let selectedPermissions = this.props.securityGroup.permissions;
        let scopes = [];

        //If already checked, un-check
        //Reset selected permissions
        if (isGroupChecked) {
            selectedPermissions = this.removePermissionsFromGroup(
                selectedPermissions
            );
            isGroupChecked = false;
        }
        //When the Access toggle for a group is selected
        //Set all permissions to true with their selected scope
        else {
            let scopeId = this.getScopeValue(id);
            let permissionsToAdd = this.findPermissionsNotInGroup();
            permissionsToAdd.forEach(permission => {
                selectedPermissions[permission.id] = {
                    ...permission,
                    scopeId
                };
                scopes.push({ name: permission.id, value: scopeId });
            });
            isGroupChecked = true;
        }

        //Send selected permissions to the security group update
        //Will update the permissions property
        this.updateSecurityGroup('permissions', selectedPermissions);
        scopes.length > 0
            ? this.setState({ isGroupChecked, scopes })
            : this.setState({ isGroupChecked });
    };

    isPermissionGroupChecked = () => {
        //Checks if the state is set to true
        if (this.state.isGroupChecked) return true;

        //If not, checks if all permissions are selected
        //If they are, set group selected to true
        let permissions = this.props.permissionGroup.permissions;
        let selectedPermissionsCount = 0;
        permissions.forEach(permission => {
            if (this.isPermissionSelected(permission.id)) selectedPermissionsCount++;
        });
        //If the number of permissions in security group
        //That match names with current permissions are equal
        //Set state to true for group checked
        if (selectedPermissionsCount === permissions.length) {
            this.setState({ isGroupChecked: true });
            return true;
        } else return false;
    };

    updateGroupScope = (groupId, value) => {
        //If the group is checked
        //Set all sub rows to the same scope
        if (this.state.isGroupChecked) {
            let securityGroup = this.props.securityGroup;
            let permissions = securityGroup.permissions;
            permissions[groupId].scopeId = value;
            securityGroup.permissions = permissions;
            this.props.updateSecurityGroup(securityGroup);
            let scopes = this.state.scopes;
            scopes.forEach(scope => {
                scope.value = parseInt(value);
            });
        }
        //Either way, update the scope in state
        this.updateScope(groupId, value);
    };

    getScopeValue = permissionName => {
        let scopes = this.state.scopes;
        let index = this.getScopeIndex(permissionName);

        //If the scope exists in state, return its value
        if (index > -1) {
            return scopes[index].value;
        }

        //Else check if it exists in the security group
        else {
            if (this.isPermissionSelected(permissionName)) {
                let permission = this.props.securityGroup.permissions[permissionName];
                return permission.scopeId;
            }
            //Default to returning 1 if nothing else succeeds
            else return 1;
        }
    };

    permissionArrayPush = permissionId => {
        let scopeId = this.getScopeValue(permissionId);
        let securityGroup = { ...this.props.securityGroup };
        let permissions = securityGroup.permissions;

        let index = this.state.permissions.findIndex(p => p.id === permissionId);
        if (index != null && index > -1) {
            let permission = this.state.permissions[index];
            if (permission.scopeable)
                permissions[permissionId] = {
                    scopeId
                };
            else {
                permissions[permissionId] = {
                };
            }
        }
    };

    dependencyChecker = permissionId => {
        const ids = this.props.permissions
            .filter(
                obj =>
                    obj['dependsOn'] !== null && obj['dependsOn'].includes(permissionId)
            )
            .map(obj => obj.id);
        return ids[0];
    };

    descriptionChecker = permissionId => {
        const ids = this.props.permissions
            .filter(
                obj =>
                    obj['dependsOn'] !== null && obj['dependsOn'].includes(permissionId)
            )
            .map(obj => obj.id);
        const desc = this.props.permissions
            .filter(
                obj =>
                    obj['id'] !== null && obj['id'].includes(ids)
            )
            .map(obj => obj.name);
        return desc[0];
    };

    getDependentPermissionIds = permission => {
        const permissionsList = this.props.permissions;
        let dependsOn = new Set(permission.dependsOn ?? []);
        for (let it = dependsOn.values(), dependencyId = null; dependencyId = it.next().value;) {
            let dependentPermission = permissionsList?.find?.(permission => permission.id === dependencyId);
            if (dependentPermission?.dependsOn) {
                dependentPermission.dependsOn.forEach(id => dependsOn.add(id));
            }
        }
        dependsOn.add(permission.id);
        return dependsOn;
    };

    getParentPermissionIdsAndNames = permission => {
        const permissionsList = this.props.permissions;
        let parentsMap = new Map();
        let parentsArray = [];
        parentsMap.set(permission.id, permission.name);
        for (let it = parentsMap.keys(), parentId = null; parentId = it.next().value;) {
            let parentPermissions = permissionsList.filter(permissionInList =>
                permissionInList?.dependsOn?.includes?.(parentId)
            );
            if (parentPermissions) {
                parentPermissions.forEach(parentPermission => {
                    if (this.isPermissionSelected(parentPermission.id)) {
                        parentsMap.set(parentPermission.id, parentPermission.name);
                    }
                })
            }
        }
        parentsMap.forEach((val, key) => {
            parentsArray.push({ id: key, name: val });
        });
        return parentsArray;
    };

    togglePermissionActive = permissionId => {
        this.setState({ currentPermission: permissionId });
        //Get the current scope value from state
        const permissionsList = this.props.permissions;
        let permission = permissionsList.find(permission => permission.id === permissionId);
        let securityGroup = { ...this.props.securityGroup };
        let permissions = securityGroup.permissions;
        let isSelected = this.isPermissionSelected(permissionId);
        if (isSelected) {
            //permission is being toggled off
            let dependentIdsAndNames = this.getParentPermissionIdsAndNames(permission);
            if (dependentIdsAndNames.length > 1) {
                this.setState({
                    permissionModal: true,
                    permissionIdsAndNames: dependentIdsAndNames.filter(dependentIdAndName =>
                        dependentIdAndName.id !== permissionId
                    )
                });
            } else {
                dependentIdsAndNames.forEach(dependentId => {
                    delete permissions[dependentId.id];
                });
            }
        } else {
            //permission is being toggled on
            let parentIds = this.getDependentPermissionIds(permission);
            parentIds.forEach(parentId => {
                this.permissionArrayPush(parentId);
            });
        }

        this.updateSecurityGroup('permissions', permissions);
        if (this.state.isGroupChecked) {
            this.setState({ isGroupChecked: false });
        }
    };

    updateSelectedOffices(id, officeIds) {
        const permissions = this.props.securityGroup.permissions;
        permissions[id] = {
            ...(permissions[id] || {}),
            officeIds
        };
        this.updateSecurityGroup('permissions', permissions);
    }

    getSelectedOffices(id) {
        const permissions = this.props.securityGroup.permissions;
        const officeIds = (permissions[id] && permissions[id].officeIds) || [];
        return officeIds.map(office => {
            for (const option of this.props.options)
                if (office === option.value) {
                    return office;
                }
        });
    }

    getScopeExclusions(id) {
        return (
            this.state.permissions.find(permission => permission.id === id)
                ?.scopeExclusions ?? []
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.showSubRows !== this.props.showSubRows) {
            this.setState({ showSubRows: this.props.showSubRows });
        }
    }

    componentDidMount() {
        //PermissionGroup is the **SORTED** permissions from the API
        //Different than a permission object to place in a security group
        //PermissionGroup includes section, group, etc
        let { permissionGroup, securityGroup, showSubRows } = this.props;
        let scopes = [];
        if (permissionGroup) {
            //If there are pre-populated scope values from the security group
            //Update state with those values
            let securityPermissions = securityGroup.permissions;
            if (securityPermissions) {
                for (let permissionId in securityPermissions) {
                    let permission = securityPermissions[permissionId];
                    let scopeId = permission.scopeId;
                    scopes.push({ name: permissionId, value: scopeId });
                }
            }
            let permissions = permissionGroup.permissions;
            this.setState({ permissionGroup, permissions, scopes, showSubRows });
        }
    }

    caretFunction = () => {
        if (this.state.showSubRows) {
            return (
                <span className="dropdown dropup">
          <span className="dropdown-toggle" /> {this.props.permissionGroup.name}
        </span>
            );
        } else {
            return (
                <span>
          <span className="dropdown dropdown-toggle" />{' '}
                    {this.props.permissionGroup.name}
        </span>
            );
        }
    };

    closeModal = () => {
        this.setState({ permissionModal: false });
    };

    submit = () => {
        let securityGroup = { ...this.props.securityGroup };
        let permissions = securityGroup.permissions;
        // when you click submit, you have to make sure they are both off and update it
        this.state.permissionIdsAndNames.forEach(permissionIdAndName => {
            delete permissions[permissionIdAndName.id];
        });
        delete permissions[this.state.currentPermission];
        this.updateSecurityGroup('permissions', permissions);
        if (this.state.isGroupChecked) this.setState({ isGroupChecked: false });
        this.setState({ permissionModal: false });
    };

    render() {
        let id = this.props.permissionGroup.permissions[0].id;
        return (
            <>
                <tr>
                    <td
                        style={firstTdStyles(this.props.disabled)}
                        onClick={this.toggleSubRows}
                    >
                        {this.caretFunction()}
                    </td>
                    <td style={tdStyles}>
                        {/*<Toggle name={this.props.permissionGroup.name} checked={this.isPermissionGroupChecked()}*/}
                        {/*  toggleSelected={this.togglePermissionGroupChecked} disabled={this.props.disabled} />*/}
                    </td>
                    <td className="border-bottom" style={lastTdStyles}>
                        <ScopeSelect
                            id={id}
                            onChange={this.updateGroupScope}
                            disabled={
                                !this.isGroupScopeable() ||
                                this.props.disabled ||
                                !this.isPermissionGroupChecked()
                            }
                            visible={false}
                            //visible={this.isGroupScopeable() && !this.props.disabled}
                            value={this.getScopeValue(id)}
                            // TODO: change to group scope override when that is implemented
                            currentOffices={this.getSelectedOffices(id)}
                            setCurrentOffices={newOffices =>
                                this.updateSelectedOffices(id, newOffices)
                            }
                        />
                    </td>
                </tr>
                {this.state.showSubRows
                    ? this.state.permissions.map((permission, i) => (
                        <tr style={subRowStyles} key={i}>
                            <td
                                style={subRowTdStyles}
                                data-tip={permission.description}
                                onMouseEnter={ReactTooltip.show()}
                            >
                                {permission.name}
                            </td>
                            <td style={{ ...tdStyles }}>
                                <Toggle
                                    name={permission.id}
                                    toggleSelected={() =>
                                        this.togglePermissionActive(permission.id)
                                    }
                                    checked={this.isPermissionSelected(permission.id)}
                                    disabled={permission.id === 'REC-LD'}
                                />
                            </td>
                            <td className="border-bottom">
                                <ScopeSelect
                                    id={permission.id}
                                    onChange={this.updateScope}
                                    value={this.getScopeValue(permission.id)}
                                    visible={
                                        permission.scopeable &&
                                        this.isPermissionSelected(permission.id)
                                    }
                                    currentOffices={this.getSelectedOffices(permission.id)}
                                    setCurrentOffices={newOffices =>
                                        this.updateSelectedOffices(permission.id, newOffices)
                                    }
                                    exclusions={this.getScopeExclusions(permission.id)}
                                    disabled={false}
                                />
                            </td>
                            <ReactTooltip
                                className="tip"
                                insecure={true}
                                multiline={true}
                            />
                            <ConfirmationModal
                                permissionIdsAndNames={this.state.permissionIdsAndNames}
                                submit={this.submit}
                                open={this.state.permissionModal}
                                close={this.closeModal}
                            />
                        </tr>
                    ))
                    : null}
            </>
        );
    }
}

PermissionGroup.propTypes = {
    permissionGroup: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    showSubRows: PropTypes.bool,
    securityGroup: PropTypes.object,
    permissions: PropTypes.array,
    options: PropTypes.array,
    updateSecurityGroup: PropTypes.func
};

function mapStateToProps(state) {
    return {
        securityGroup: state.securityGroup.securityGroup,
        permissions: state.securityGroup.permissions,
        options: state.roster.offices.map(office => ({
            value: office.id,
            label: office.shortName
        }))
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ updateSecurityGroup }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PermissionGroup);
